import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4501Model } from '../kymw4501.model';

// レスポンス構造
export type GetFixFeatureResponse = {
  MediumType: string;
  MediumName: string;
  FeatureCode: string;
  SeaqenceCode: string;
  FeatureName: string;
};

/**
 * 固定特集一覧取得
 *
 * @export GetFixFeatureService
 * @class GetFixFeatureService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetFixFeatureService extends PlessJsonResponderSub<GetFixFeatureResponse[]> {
  private vo = {
    mediumType: '',
    featureCode: '',
  };
  private successFunc: Function;
  private model: KYMW4501Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.vo.mediumType,
        FeatureCode: this.vo.featureCode
      },
    });
  }

  /**
   * API呼び出し
   * @param vo 
   * @param successFunc
   * @memberof GetCodeListService
   */
  execute(model: KYMW4501Model, successFunc: Function = null): void {
    this.model = model;
    this.vo.mediumType = model.mediumType;
    this.vo.featureCode = model.featureCode;
    this.successFunc = successFunc;
    this.send('getFixFeature', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: GetFixFeatureResponse[]) {
    this.model.setFixedSpecialFeatureList(data);
    if (this.successFunc) this.successFunc();
  }
}
